import { mdiClose, mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { Col, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './RejectRequestModal.scss';

function RejectRequestModal({
  isOpen,
  toggle,
  onChange,
  value,
  handleRejection,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="approval-cancel-icon">
            <Icon path={mdiFileRemoveOutline} size={0.7} />
          </div>
          <div>
            <button type="button" className="btn btn-link p-0" onClick={toggle}>
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Confirmation</h5>
          <p>Are you sure you want to reject this request?</p>
        </div>
        <Label>
          Reason<span className="text-danger">*</span>
        </Label>
        <Input
          placeholder="Enter"
          type="textarea"
          rows="4"
          onChange={e => onChange(e.target.value)}
          value={value}
        />
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="custom-light-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={handleRejection}
          >
            Yes, Reject
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default RejectRequestModal;
